import { PlanillaPartido } from '../PlanillaPartido/PlanillaPartido';
import { TorneoListaBuenaFeOficialAuxiliar } from '../TorneoListaBuenaFeOficialAuxiliar/TorneoListaBuenaFeOficialAuxiliar';

export interface PlanillaPartidoOficialAuxiliarJSON {
  ppoa_id: string | null;
  ppoa_ppid: number;
  ppoa_eqid: number;
  ppoa_nombre: string;
  ppoa_apellido: string;
  ppoa_dni: string;
  ppoa_orden: string;
  __delete: boolean;
}

export class PlanillaPartidoOficialAuxiliar {
  protected constructor(
    private id: string | null,
    private ppid: number,
    private eqid: number,
    private nombre: string,
    private apellido: string,
    private dni: string,
    private orden: string,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    ppid: number,
    eqid: number,
    nombre: string,
    apellido: string,
    dni: string,
    orden: string,
    __delete: boolean
  ) {
    return new this(id, ppid, eqid, nombre, apellido, dni, orden, __delete);
  }

  static createFromBuenaFe(planillaId: number, ofAuxBuenaFe: TorneoListaBuenaFeOficialAuxiliar) {
    return PlanillaPartidoOficialAuxiliar.createFrom(
      '',
      +planillaId!,
      +ofAuxBuenaFe.getTorneoListaBuenaFe()!.getEqid(),
      ofAuxBuenaFe.getNombre(),
      ofAuxBuenaFe.getApellido(),
      ofAuxBuenaFe.getDocumentoNumero(),
      ofAuxBuenaFe.getOrden(),
      false
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoOficialAuxiliar) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoOficialAuxiliarJSON) {
    return PlanillaPartidoOficialAuxiliar.createFrom(
      entity.ppoa_id,
      entity.ppoa_ppid,
      entity.ppoa_eqid,
      entity.ppoa_nombre,
      entity.ppoa_apellido,
      entity.ppoa_dni,
      entity.ppoa_orden,
      entity.__delete
    );
  }

  toJSON(): PlanillaPartidoOficialAuxiliarJSON {
    const ret: PlanillaPartidoOficialAuxiliarJSON = {
      ppoa_id: this.getId(),
      ppoa_ppid: this.getPpid(),
      ppoa_eqid: this.getEqid(),
      ppoa_nombre: this.getNombre(),
      ppoa_apellido: this.getApellido(),
      ppoa_dni: this.getDni(),
      ppoa_orden: this.getOrden(),
      __delete: this.__delete,
    };

    return ret;
  }

  isActive(): boolean {
    return !this.__delete;
  }

  getId(): string | null {
    return this.id;
  }

  getPpid(): number {
    return this.ppid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDni(): string {
    return this.dni;
  }

  getOrden(): string {
    return this.orden;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setPpid(value: number): void {
    this.ppid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDni(value: string): void {
    this.dni = value;
  }

  setOrden(value: string): void {
    this.orden = value;
  }
  setDeleted(d: boolean) {
    this.__delete = d;
  }
}
